import React, {useEffect, useState} from "react";
import Breadcrumbs from "../../../components/breadcrumbs";
import {useDispatch, useSelector} from "react-redux";
import {useHistory, useParams} from "react-router-dom";
import LoadingSpinner from '../../../components/loading-spinner';
import Button from "../../../components/button";
// import SelectInput from "../../../components/select";
import Input from "../../../components/input";
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {ReactComponent as ReactLogo} from '../../../button.svg';
import {searchResultsQuery, searchResultsQueryZone} from "../../../redux/activities";
import Footer from "../../../components/footer";
import Select from "react-select";
import {get_report, GET_REPORT, clear_activity} from "../../../redux/activities";

const ResultsQueryItem = (props) => {
    let history = useHistory();
    const dispatch = useDispatch();

    const {id_hoja_trabajo, nombre, id_store, tienda, fecha_inicio, fecha_fin} = useParams();

    const {token, user} = useSelector((state) => state.users_module.login.data) || null;
    const _get_all_stores = useSelector((state) => state.stores_module._get_all_stores);
    const _get_all_zones = useSelector((state) => state.zones_module._get_all_zones);
    const _get_report = useSelector((item) => item.activities_module._get_report);

    const [id_tienda, setIdTienda] = useState(parseInt(id_store));
    const [id_zone, setIdZone] = useState(0);
    const [select_tienda, setSelectTienda] = useState(id_store > 0 ? [{label: tienda, value: id_store}] : []);
    const [select_zone, setSelectZone] = useState([]);
    const [stores, setStores] = useState([]);
    const [zones, setZones] = useState([]);
    const [dateStart, setDateStart] = useState(fecha_inicio);
    const [dateStartZone, setDateStartZone] = useState('');
    const [dateEnd, setDateEnd] = useState(fecha_fin);
    const [dateEndZone, setDateEndZone] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [datas, setDatas] = useState([]);
    const [datasZones, setDatasZones] = useState([]);

    useEffect(() => {
        // getStores();
        if (_get_all_stores.data.datos) {
            let v = _get_all_stores.data.datos.filter(x => x.activo === true);
            setStores(v);
        }
        // eslint-disable-next-line
    }, [user]);

    useEffect(() => {
        // getStores();
        if (_get_all_zones.data.datos) {
            let z = _get_all_zones.data.datos.filter(x => x.activo === true);
            setZones(z);
        }
        // eslint-disable-next-line
    }, [user]);

    // async function getStores() {
    //     setIsLoading(true);
    //     const params = '?usuario=' + user;
    //     try {
    //         const response = await searchStores(token, params);
    //         if (response && response.data && response.data.datos) {
    //             setStores(response.data.datos);
    //         }
    //         setIsLoading(false);
    //     } catch (e) {
    //         setIsLoading(false);
    //     }
    // }

    useEffect(() => {
        if (id_store !== 0) {
            getResultsQuery(false);
        }
        // eslint-disable-next-line
    }, [id_store]);

    async function getResultsQuery(valid) {
        setIsLoading(true);
        if (valid === true && id_tienda === 0) {
            toast.error("Debe seleccionar una tienda", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (dateStart === '') {
            toast.error("Debe seleccionar una fecha de inicio", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (dateEnd === '') {
            toast.error("Debe seleccionar una fecha final", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        let params = '?id_hoja_trabajo=' + id_hoja_trabajo + '&&id_tienda=' + id_tienda + '&&fecha_inicio=' + dateStart + '&&fecha_fin=' + dateEnd;
        try {
            const response = await searchResultsQuery(token, params);
            if (response && response.data && response.data.datos) {
                setDatas(response.data.datos);
            }
            setIsLoading(false);
        } catch (e) {
           setIsLoading(false);
        }
    }

    async function getResultsQueryZone(valid) {
        setIsLoading(true);
        if (valid === true && id_zone === 0) {
            toast.error("Debe seleccionar una zona", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (dateStartZone === '') {
            toast.error("Debe seleccionar una fecha de inicio", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (dateEndZone === '') {
            toast.error("Debe seleccionar una fecha final", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        let params = '?id_hoja_trabajo=' + id_hoja_trabajo + '&&id_zona=' + id_zone + '&&fecha_inicio=' + dateStartZone + '&&fecha_fin=' + dateEndZone;
        try {
            const response = await searchResultsQueryZone(token, params);
            if (response && response.data && response.data.datos) {
                setDatasZones(response.data.datos);
            }
            setIsLoading(false);
        } catch (e) {
           setIsLoading(false);
        }
    }

    const handleChangeStore = (e) => {
        setIdTienda(parseInt(e.value));
        setSelectTienda(e);
    }

    const handleChangeZone = (e) => {
        setIdZone(parseInt(e.value));
        setSelectZone(e);
    }

    useEffect(() => {
        if (_get_report.status === 200) {
            toast.success(_get_report.data.mensaje);
            dispatch(clear_activity(GET_REPORT));
            setIsLoading(false);
        } else if (_get_report.status !== 0) {
            toast.error(_get_report.message);
            dispatch(clear_activity(GET_REPORT));
            setIsLoading(false);
        }
    }, [_get_report, dispatch])

    const handleGenerateReport = (e) => {
            e.preventDefault();
            setIsLoading(true);

            let tiendas = [];
            
            datasZones.forEach(x => {
                tiendas.push(x.id_tienda)
            })

            dispatch(get_report(token,
                {
                    'tiendas': tiendas, 
                    'id_hoja_trabajo': id_hoja_trabajo, 
                    'fecha_inicio': dateStartZone, 
                    'fecha_fin': dateEndZone,
                    'tipo': 'ZONA'
                }
            ));
        }

    return (
        <div className="app-content content">
            <div className="content-overlay"/>

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Hoja de trabajo"
                            items={[{label: "Consulta de resultados", link: "/consulta-resultados"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div><ToastContainer/></div>
                    {isLoading && <LoadingSpinner/>}
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                                <div className="d-flex">
                                    <div style={{cursor: 'pointer'}} onClick={() => {
                                        history.push(`/consulta-resultados`);
                                    }}>
                                        <ReactLogo width={50} heght={40}/>
                                    </div>
                                    <p className="ml-1" style={{marginTop: 5, fontSize: 18, color: '#727E8C'}}>Consulta de {nombre}</p>
                                </div>
                                <div className="row mt-1">
                                    <div className="border_card col-12">
                                        <div className="row">
                                            <div className="col-md-3 col-sm-6 col-12">
                                                <div className="form-group">
                                                    <label>Tienda</label>
                                                    <Select
                                                         options={stores ? stores.map((item) => ({
                                                            label: item.nombre,
                                                            value: item.id,
                                                        })) : []}
                                                        isMulti={false}
                                                        onChange={handleChangeStore}
                                                        value={select_tienda}
                                                    />
                                                    {/* <SelectInput
                                                        label="Tienda"
                                                        name="id_tienda"
                                                        value={id_tienda}
                                                        select={tienda}
                                                        onChange={(e) => setIdTienda(parseInt(e.target.value))}
                                                        options={stores ? stores.map((item) => ({
                                                            name: item.nombre,
                                                            id: item.id,
                                                        })) : []}
                                                    /> */}
                                                </div>
                                            </div>
                                            <div className="col-md-3 col-sm-6 col-12">
                                                <Input
                                                    name="dateStart"
                                                    label="Desde"
                                                    type="date"
                                                    value={dateStart}
                                                    onChange={(e) => {setDateStart(e.target.value)}}
                                                />
                                            </div>
                                            <div className="col-md-3 col-sm-6 col-12">
                                                <Input
                                                    name="dateEnd"
                                                    label="Hasta"
                                                    type="date"
                                                    value={dateEnd}
                                                    onChange={(e) => {setDateEnd(e.target.value)}}
                                                />
                                            </div>
                                            <div className="col-md-3 col-sm-6 col-12 text-center mt-2">
                                                <Button type="button" text="Buscar" theme="calendar" onClick={() => {
                                                    getResultsQuery(true);
                                                }}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-1">
                                    <div className="col-12">
                                        <div className="table-responsive">
                                            <table className='table table-hover'>
                                                <thead>
                                                    <tr>
                                                        <th className="text-center">Nombre</th>
                                                        <th className="text-center">Tienda</th>
                                                        <th className="text-center">Fecha de inicio</th>
                                                        <th className="text-center">Fecha final</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {datas &&
                                                        datas.map(v => (
                                                            <tr onClick={() =>{
                                                                history.push(`/resultado/procesos/${id_hoja_trabajo}/${nombre}/${id_tienda}/${v.tienda}/${dateStart}/${dateEnd}`);
                                                            }}>
                                                                <td>{v.nombre}</td>
                                                                <td>{v.tienda}</td>
                                                                <td className="text-center">{v.fecha_inicio}</td>
                                                                <td className="text-center">{v.fecha_fin}</td>
                                                            </tr>
                                                        ))    
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-1">
                                    <div className="border_card col-12">
                                        <div className="row">
                                            <div className="col-md-3 col-sm-6 col-12">
                                                <div className="form-group">
                                                    <label>zona</label>
                                                    <Select
                                                         options={zones ? zones.map((item) => ({
                                                            label: item.nombre,
                                                            value: item.id,
                                                        })) : []}
                                                        isMulti={false}
                                                        onChange={handleChangeZone}
                                                        value={select_zone}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3 col-sm-6 col-12">
                                                <Input
                                                    name="dateStartZone"
                                                    label="Desde"
                                                    type="date"
                                                    value={dateStartZone}
                                                    onChange={(e) => {setDateStartZone(e.target.value)}}
                                                />
                                            </div>
                                            <div className="col-md-3 col-sm-6 col-12">
                                                <Input
                                                    name="dateEndZone"
                                                    label="Hasta"
                                                    type="date"
                                                    value={dateEndZone}
                                                    onChange={(e) => {setDateEndZone(e.target.value)}}
                                                />
                                            </div>
                                            <div className="col-md-3 col-sm-6 col-12 text-center mt-2">
                                                <Button type="button" text="Buscar" theme="calendar" onClick={() => {
                                                    getResultsQueryZone(true);
                                                }}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-1">
                                    <div className="col-12">
                                        <div className="table-responsive">
                                            <table className='table table-hover'>
                                                <thead>
                                                    <tr>
                                                        <th className="text-center">Nombre</th>
                                                        <th className="text-center">Tienda</th>
                                                        <th className="text-center">Fecha de inicio</th>
                                                        <th className="text-center">Fecha final</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {datasZones &&
                                                        datasZones.map(v => (
                                                            <tr>
                                                                <td>{v.nombre}</td>
                                                                <td>{v.tienda}</td>
                                                                <td className="text-center">{v.fecha_inicio}</td>
                                                                <td className="text-center">{v.fecha_fin}</td>
                                                            </tr>
                                                        ))    
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="col-12 text-right">
                                        {datasZones.length > 0 &&
                                            <Button type="button" text="Enviar" theme="calendar" onClick={handleGenerateReport}/>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
};

export default ResultsQueryItem;
